module.exports = __webpack_public_path__ + "static/img/little.ce313b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/little.png
// module id = mAFt
// module chunks = 1